import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

/* Views */
import MainContent from './views/MainContent';
import InstructionsPage from './views/InstructionsPage';
import ReturnMicScreen from './views/iPod/ReturnMicScreen';
// import ReturnMusicsScreen from './views/iPod/ReturnMusicsScreen';
import ReturnMusicsNewScreen from './views/iPod/ReturnMusicsNewScreen';
import ReturnMusicsNewScreen2 from './views/iPod/ReturnMusicsNewScreen2';
import ReturnMusicsMenuScreen from './views/iPod/ReturnMusicsMenuScreen';
import AccessDeniedScreen from './views/iPod/ReturnAccessDeinedScreen';
/* TESTES */
import Visualizer from './components/Visualizer';
import MusicExample from './components/Screens/MusicExample';
import ArtExampleP5 from './components/Screens/ArtExampleP5';
import ReturnAccessDeniedScreen from './components/Screens/AccessDeniedScreen';
// import MusicExampleP5 from './components/Screens/MusicExampleP5';
// import MusicFFTScreen from './components/Screens/MusicFFTScreen';
// import MusicFFTScreen2 from './components/Screens/MusicFFTScreen2';

import fire from './views/LoginPage/fire.js';

import LoginPage from './views/LoginPage';
import Logout from './views/LoginPage/Logout';

import ConfigScreen from './components/Screens/ConfigScreen';

export default class Routes extends Component {
    render() {
        const user = fire.auth().currentUser;
        // const sla = user.emailVerified
        // console.log(user.emailVerified)

        // const handleLogout = () => {
        //     fire.auth().signOut();
        // }

        return(
            <BrowserRouter>
                <Switch>
                    { user ? (
                        <>
                            <Route exact path="/" component={MainContent} />
                        </>
                    ) : (

                        <Route exact path="/" component={LoginPage} />


                        // <>
                        //     <Route exact path="/" component={LoginPage} />
                        //     { user ? (
                        //         <>
                                    
                        //         </>
                        //     ) : (
                        //         <>
                        //             <Route path="/a" component={ReturnAccessDeniedScreen} />
                        //             <Route path="/musics" component={ReturnAccessDeniedScreen} />
                        //             <Route path="/music/1" component={ReturnAccessDeniedScreen} />
                        //             <Route path="/music/2" component={ReturnAccessDeniedScreen} />
                        //             <Route path="/art" component={ReturnAccessDeniedScreen} />
                        //             <Route path="/mic" component={ReturnAccessDeniedScreen} />
                        //             <Route path="/config" component={ReturnAccessDeniedScreen} />
                        //         </>
                        //     )
                        //     }
                        // </>
                    )
                    }

                    <Route path="/a" component={ReturnMusicsNewScreen} />
                    <Route path="/musics" component={ReturnMusicsMenuScreen} />
                    <Route path="/music/1" component={ReturnMusicsNewScreen} />
                    <Route path="/music/2" component={ReturnMusicsNewScreen2} />
                    <Route path="/art" component={ArtExampleP5} />
                    <Route path="/mic" component={ReturnMicScreen} />
                    <Route path="/config" component={ConfigScreen} />
                    <Route path="/instructions" component={InstructionsPage} />

                    
                    {/* <Route path="/login" component={LoginPage} />
                    <Route path="/a" component={ReturnMusicsNewScreen} />
                    <Route path="/musics" component={ReturnMusicsMenuScreen} />
                    <Route path="/music/1" component={ReturnMusicsNewScreen} />
                    <Route path="/music/2" component={ReturnMusicsNewScreen2} />
                    <Route path="/art" component={ArtExampleP5} />
                    <Route path="/mic" component={ReturnMicScreen} />
                    <Route path="/logout" component={Logout} /> */}

                </Switch>
            </BrowserRouter>
        );
    }
}



